var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "stlFullscreen",
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          return _vm.$emit("close")
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "stlFullscreenToolbar",
          on: {
            click: function ($event) {
              if ($event.target !== $event.currentTarget) return null
              return _vm.$emit("close")
            },
          },
        },
        [
          _c("div", { staticClass: "stlFullscreenTitle" }, [
            _vm._v(_vm._s(_vm.lookTitle)),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "stlFullscreenClose",
              attrs: { type: "button", "aria-label": "Ansicht schliessen" },
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            },
            [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "stlFullscreenViewport",
          on: {
            click: function ($event) {
              if ($event.target !== $event.currentTarget) return null
              return _vm.$emit("close")
            },
          },
        },
        [
          _c(
            "button",
            {
              staticClass: "stlFullscreenNav stlFullscreenNavPrev",
              attrs: {
                type: "button",
                "aria-label": "Vorherigen Look anzeigen",
                disabled: _vm.isPrevDisabled,
              },
              on: {
                click: function ($event) {
                  return _vm.$emit("request-previous")
                },
              },
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    viewBox: "0 0 24 24",
                    width: "28",
                    height: "28",
                    "aria-hidden": "true",
                  },
                },
                [_c("polyline", { attrs: { points: "15 18 9 12 15 6" } })]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "stlFullscreenLook" },
            [
              _c("shop-the-look-item", {
                key: _vm.activeLook.id,
                attrs: {
                  config: _vm.activeLook,
                  "show-magnifier": false,
                  "show-master-link": false,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "stlFullscreenMeta",
              on: {
                click: function ($event) {
                  if ($event.target !== $event.currentTarget) return null
                  return _vm.$emit("close")
                },
              },
            },
            [
              _vm.isVariantGroup
                ? _c(
                    "div",
                    {
                      staticClass: "stlFullscreenVariants",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                        },
                      },
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "stlFullscreenVariantStep",
                          attrs: {
                            type: "button",
                            "aria-label": "Vorherige Variante anzeigen",
                          },
                          on: { click: _vm.showPreviousVariant },
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                viewBox: "0 0 24 24",
                                width: "20",
                                height: "20",
                                "aria-hidden": "true",
                              },
                            },
                            [
                              _c("polyline", {
                                attrs: { points: "15 18 9 12 15 6" },
                              }),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "stlFullscreenVariantList" },
                        _vm._l(_vm.variants, function (variant) {
                          return _c(
                            "button",
                            {
                              key: variant.id,
                              staticClass: "stlFullscreenVariantThumb",
                              class: {
                                active:
                                  Number(variant.id) ===
                                  Number(_vm.activeLook.id),
                              },
                              attrs: {
                                type: "button",
                                "aria-label": _vm.variantTitle(variant),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.selectVariant(variant.id)
                                },
                              },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: variant.imageUrl,
                                  alt: _vm.variantTitle(variant),
                                  loading: "lazy",
                                },
                              }),
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "stlFullscreenVariantStep",
                          attrs: {
                            type: "button",
                            "aria-label": "Naechste Variante anzeigen",
                          },
                          on: { click: _vm.showNextVariant },
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                viewBox: "0 0 24 24",
                                width: "20",
                                height: "20",
                                "aria-hidden": "true",
                              },
                            },
                            [
                              _c("polyline", {
                                attrs: { points: "9 18 15 12 9 6" },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.lookTags.length
                ? _c(
                    "div",
                    { staticClass: "stlFullscreenTags" },
                    _vm._l(_vm.lookTags, function (tag) {
                      return _c(
                        "button",
                        {
                          key: tag.id,
                          staticClass: "stlFullscreenTag",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("select-tag", tag.id)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(tag.value) + "\n        "
                          ),
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _vm.isLoading
            ? _c(
                "div",
                {
                  staticClass: "stlFullscreenLoading",
                  attrs: { role: "status", "aria-live": "polite" },
                },
                [
                  _c("span", {
                    staticClass: "stlFullscreenLoadingSpinner",
                    attrs: { "aria-hidden": "true" },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Lade weitere Looks...")]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "stlFullscreenNav stlFullscreenNavNext",
              attrs: {
                type: "button",
                "aria-label": "Naechsten Look anzeigen",
                disabled: _vm.isNextDisabled,
              },
              on: {
                click: function ($event) {
                  return _vm.$emit("request-next")
                },
              },
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    viewBox: "0 0 24 24",
                    width: "28",
                    height: "28",
                    "aria-hidden": "true",
                  },
                },
                [_c("polyline", { attrs: { points: "9 18 15 12 9 6" } })]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }